






















































































































































































































































































































































































































































    import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
    import { formatLotType, formatLotStatus } from '@/data/lot';
    import SmoothReflow from '@/components/SmoothReflow.vue';
    import BRSModal from '@/components/prescriber/BRSModal.vue';
    import HeaderDatatable from '@/models/HeaderDatatable';
    import MetaDatatable from '@/models/MetaDatatable';
    import Datatable from '@/components/Datatable.vue';
    import FiltersModule from '@/store/FiltersModule';
    import { getLotsPrescriber, getRequestUpdate } from '@/api/api';
    import ListModule from '@/store/ListModule';
    import Program from '@/models/Program';
    import AuthModule from "@/store/AuthModule";
    import {isBrs} from '@/utils/isBrs'
    import Lot from '@/models/Lot';
    import moment from 'moment';
    import MapModule from '@/store/MapModule';
    import { BACKEND_URL } from '@/helpers/constants';
    import { buildDocumentUrl } from '@/helpers/document';
    import { getTaxSystemColor, getTaxSystemValue } from '@/data/taxSystems';
    import Lightbox from '@/components/Lightbox.vue';
    import HonoModal from '@/components/prescriber/HonoModal.vue';
    import getOptionInfos from '../../utils/notifications';

    import { exposures } from '@/data/types';
    import PdfThumbnail from '@/components/prescriber/PdfThumbnail.vue';


    @Component({
        filters: {
            formatLotType,
            getTaxSystemValue,
            formatLotStatus,
            date: function (value: string, program?: any) {
                const today = moment();

                if (!value) {
                    if (program && program.tax_system && program.tax_system.some((tax: string) => tax.includes('Revente'))) {
                        const currentQuarter = today.format('Q');
                        const currentYear = today.format('YYYY');
                        return `${currentQuarter}T ${currentYear}`;
                    } else {
                        return 'NC';
                    }
                }

                const deliveryDate = moment(value);

                if (deliveryDate.isBefore(today, 'day')) {
                    const currentQuarter = today.format('Q');
                    const currentYear = today.format('YYYY');
                    return `${currentQuarter}T ${currentYear}`;
                }

                const quarter = deliveryDate.format('Q');
                const year = deliveryDate.format('YYYY');
                return `${quarter}T ${year}`;
            },
            euro: function (value: number) {
                return new Intl.NumberFormat('fr-FR', {
                    style: 'currency',
                    currency: 'EUR',
                    minimumFractionDigits: 0,
                }).format(value);
            },
            formatDate: (value: string) => {
                let date1 = new Date(value);
                let date2 = new Date();
                let timeDiff = Math.abs(date2.getTime() - date1.getTime());
                let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

                // Les heures H ici represente les J
                if (diffDays === 0) {
                    return '-1h'
                } else if (diffDays <= 7) {
                    return '-7h'
                }else if (diffDays > 7) {
                    return '+7h'
                }
            },
            formatYMD: (value: string) => {
                let d = new Date(value);
                let mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d);
                let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
                return `(${da}-${mo})`;
            },
            pricePerSquareMeter: (value: number) => {
                const val = new Intl.NumberFormat('fr-FR', {
                    style: 'decimal',
                    currency: 'EUR',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                }).format(value);

                return `${val}/m²`;
            },
        },
        components: {
            SmoothReflow,
            Datatable,
            Lightbox,
            BRSModal,
            HonoModal,
            PdfThumbnail,
        }
    })
    export default class ProgramItem extends Vue {
        @Prop() program!: Program;
        @Prop() lotsSelected!: any;
        open: boolean = this.isDenounceSelected;
        lotsLoaded: boolean = this.isDenounceSelected;

        brsOpen: boolean = false;
        honoOpen: boolean = false;

        showHonoValue: boolean = false;

        BACKEND_URL = BACKEND_URL;
        imageModal: string | null = null;
        imageLoadError: boolean = false;
        lotPlanBroken: number[] = [];
        lotIndexMap: {[key: number]: number} = {};

        planUrl(plan: any) {
            return buildDocumentUrl(this.BACKEND_URL, plan);
        }

        markPlanBroken(lotId: number) {
            if (!this.lotPlanBroken.includes(lotId)) {
                this.lotPlanBroken.push(lotId);
            }
        }

        commissionRate: number = 0;
        withHono: boolean = false;


        smoothReflowSettings = {
            transitionEvent: {
                selector: 'div',
                propertyName: 'opacity',
            },
        };
        lotSelect(lot: any) {
            this.$emit('lotSelect', lot);
        }


        @Watch('program', { deep: false })
            onProgram(newVal: Program, oldVal: Program) {
                if (oldVal && newVal.id === oldVal.id) return;
                this.open = false;
                this.lotsLoaded = false;
                this.imageLoadError = false;
                this.lotPlanBroken = [];
            }

        @Watch('open')
        async onOpen(isOpen: boolean) {
            if (isOpen && !this.lotsLoaded) {
                await new Promise(resolve => setTimeout(resolve, 100));
                this.lotsLoaded = true;
            }
        }

        get programsBookmarked(): Program[] {
            return ListModule.programsBookmarked;
        }
        get getOptionInfos() {
            return getOptionInfos;
        }


        created() {
            this.loadCommissionRateFromAuth();
        }

        handleImageError() {
                this.imageLoadError = true;
            }




        copyAddress(): void {
            if (this.program && this.program.address) {
                const { street, postal_code, city } = this.program.address;

               const fullAddress = `${street || ''} ${postal_code || ''} ${city || ''}`.trim();

                if ((navigator as any).clipboard && (window as any).isSecureContext) {
                    (navigator as any).clipboard.writeText(fullAddress)
                        .then(() => {
                            this.showSuccessMessage();
                        })
                        .catch((err: any) => {
                            console.warn('API Clipboard échouée:', err);
                            this.oldMethodCopy(fullAddress);
                        });
                } else {
                    this.oldMethodCopy(fullAddress);
                }
            }
        }




             loadCommissionRateFromAuth() {
                        const raw = localStorage.getItem('auth');

                        if (!raw) return;

                        try {
                        const auth = JSON.parse(raw);
                        const subs = Array.isArray(auth.subscriptions) ? auth.subscriptions : [];
                        if (subs.length === 0) return;
                        const last = subs[subs.length - 1];

                        console.log('[Auth] last.with_hono =', last.with_hono,
                                    ', last.commission_rate =', last.commission_rate);

                        this.withHono = !!last.with_hono;
                        this.commissionRate = typeof last.commission_rate === 'string'
                            ? parseFloat(last.commission_rate)
                            : Number(last.commission_rate) || 0;

                        console.log('[Auth] this.withHono =', this.withHono,
                                    ', this.commissionRate =', this.commissionRate);
                        } catch (e) {
                        console.error('[Auth] JSON.parse error:', e);
                        }
                    }

                    get netHono(): number {
                        const base = Number(this.program.duty_free_fee) || 0;
                        const net = base - this.commissionRate;
                        return net > 0 ? Math.round(net * 100) / 100 : 0;
                    }

                    getHonoClass() {
                        let honoValue = 0;

                        if (this.withHono && this.commissionRate > 0) {
                            honoValue = this.netHono;
                        } else {
                            honoValue = this.program.duty_free_fee || 0;
                        }

                        if (honoValue === 0) {
                            return 'hono-nc';
                        } else if (honoValue < 3) {
                            return 'hono-low';
                        } else if (honoValue < 6) {
                            return 'hono-medium';
                        } else {
                            return 'hono-high';
                        }
                    }



            oldMethodCopy(text: string): void {
            const input: HTMLInputElement = document.createElement('input');
            input.value = text;
            input.style.position = 'fixed';
            input.style.top = '-9999px';
            input.style.opacity = '0';

            document.body.appendChild(input);
            input.select();

            let copied: boolean = false;
            try {
                copied = document.execCommand('copy');
            } catch (e) {
                console.error('Erreur copie:', e);
            }

            document.body.removeChild(input);

            if (copied) {
                this.showSuccessMessage();
            } else {
                this.showErrorMessage();
            }
            }

            showSuccessMessage(): void {
            const $vs: any = (this as any).$vs;
            if ($vs && $vs.notify) {
                $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Copié',
                text: 'Adresse copiée dans le presse-papier',
                });
            }
            }

            showErrorMessage(): void {
            const $vs: any = (this as any).$vs;
            if ($vs && $vs.notify) {
                $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: 'Impossible de copier l\'adresse automatiquement',
                });
            }
            }


        get exposuresMapping() {
            return exposures;
        }


        async sendUpdateRequested(program: Program) {
            const $vs = (this as any).$vs;
            if(program.id != null && program.id) {
                getRequestUpdate(program.id);
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'MAJ',
                    text: `Demande envoyée`,
                });
            }
        }

        get dynamicColumns(): HeaderDatatable[] {
    let finalCols = [...this.columns];

    if (this.program && this.program.tax_system) {
        const isDemembrement = this.program.tax_system.includes('Démembrement de propriété');

        const priceColumn = finalCols.find(col =>
            col.dataIndex === 'price' &&
            col.title === 'Prix total TTC'
        );
        if (isDemembrement && priceColumn) {
            priceColumn.title = 'Prix Pleine Propriété';
        }

        const hasBRS = this.program.tax_system.includes('BRS');
        if (!hasBRS) {
            finalCols = finalCols.filter(c => c.dataIndex !== 'price_reduced_brs');
        }

        const hasLLI = this.program.tax_system.includes('LLI');
        if (!hasLLI) {
            finalCols = finalCols.filter(c => c.dataIndex !== 'price_reduced_lli');
        }

       const hasTVAReduite = this.program.tax_system.includes('RP Tva Réduite/Prix Maitrisé');
            if (!hasTVAReduite) {
                finalCols = finalCols.filter(c => c.dataIndex !== 'price_vat_reduce_or_controlled');
            }

        const hasNuePropriete = this.program.tax_system.includes('Démembrement de propriété');
        if (!hasNuePropriete) {
            finalCols = finalCols.filter(c => c.dataIndex !== 'prix_nue_propriete');
        }
    } else {
        finalCols = finalCols.filter(c =>
            c.dataIndex !== 'price_reduced_brs' &&
            c.dataIndex !== 'price_reduced_lli' &&
            c.dataIndex !== 'price_vat_reduce_or_controlled' &&
            c.dataIndex !== 'prix_nue_propriete'
        );
    }

    return finalCols;
}


        get promotorStars() {
            if (!this.program || !this.program.promoter) {
                return [];
            }

            if(this.program.promoter.nb_of_stars){
                let nbOfStars = [];
                let counter = 0;
                while (counter < this.program.promoter.nb_of_stars) {
                    counter++;
                    nbOfStars.push(counter);
                }
                return nbOfStars;
            }
        }

        get promotorStarsNegative() {
            if (!this.program || !this.program.promoter) {
                return [];
            }

            if(this.program.promoter.nb_of_stars){
                let nbOfStarsNegative = [];
                let counter = 0;
                while (counter < (5 - this.program.promoter.nb_of_stars)) {
                    counter++;
                    nbOfStarsNegative.push(counter);
                }
                return nbOfStarsNegative;
            }
        }

        brs(lot: Lot) {
            return isBrs(lot, this.program)
        }

        meta: MetaDatatable = {
            total: 0,
            pages: 0,
            page: 1,
            perPage: 5,
            search: null,
            orderBy: null,
            orderWay: null,
            filters: null,
        };
        columns: HeaderDatatable[] = [
            {
                title: 'Plan',
                dataIndex: 'plan',
                width: 110,
                scopedSlots: {
                    customRender: 'plan',
                },
            },

            {
                title: 'Statut',
                dataIndex: 'status',
                scopedSlots: {
                    customRender: 'status',
                },
                sorter: true,
            },


            {
                title: 'Nom',
                dataIndex: 'name',
                scopedSlots: {
                    customRender: 'name',
                },
                sorter: true,
            },
            {
                title: 'Type',
                dataIndex: 'type2',
                scopedSlots: {
                    customRender: 'type2',
                },
                sorter: true,
            },


            {
                title: 'Prix total TTC',
                dataIndex: 'price',
                scopedSlots: {
                    customRender: 'price',
                },
                sorter: true,
            },


            {
                title: 'Prix TVA réduite/Prix maitrisé',
                dataIndex: 'price_vat_reduce_or_controlled',
                scopedSlots: {
                    customRender: 'price_vat_reduce_or_controlled',
                },
                sorter: true,
            },




            {
                title: 'Étage',
                dataIndex: 'floor',
                sorter: true,
            },


            {
                title: 'Sdp',
                dataIndex: 'surface_carrez',
                scopedSlots: {
                    customRender: 'surface',
                },
                sorter: true,
            },




            {
                title: 'M² Ext',
                dataIndex: 'surface_terrace',
                scopedSlots: {
                    customRender: 'surface_terrace',
                },
                sorter: true,
            },


            {
                title: 'm² jardin',
                dataIndex: 'surface_copro_garden',
                scopedSlots: { customRender: 'surface_copro_garden' },
                sorter: true,
            },


            {
                title: 'Expo',
                dataIndex: 'exposure',
                scopedSlots: {
                    customRender: 'exposure',
                },
                sorter: true,
            },


            {
                title: 'Prix /m²',
                dataIndex: 'price',
                scopedSlots: {
                    customRender: 'price_per_meter',
                },
                sorter: false,
            },

            {
                title: 'Prix BRS TVA 5,5%',
                dataIndex: 'price_reduced_brs',
                scopedSlots: {
                    customRender: 'price_reduced_brs',
                },
                sorter: true,
            },
            {
                title: 'Prix Nue-Proprieté',
                dataIndex: 'prix_nue_propriete',
                scopedSlots: {
                    customRender: 'prix_nue_propriete',
                },
                sorter: true,
            },
            {
                title: 'Prix LLI (Tva 10%)1',
                dataIndex: 'price_reduced_lli',
                scopedSlots: {
                    customRender: 'price_reduced_lli',
                },
                sorter: true,
            },



            {
                title: '',
                dataIndex: 'action',
                scopedSlots: {
                    customRender: 'actions',
                },
                width: 24,
                fixed: 'right',
            },
        ];
        programSelect(program: any) {
            ListModule.selectProgram(program.id);
        }

        @Watch('filters', { deep: true })
        onFilters() {
            this.meta.filters = this.filters;
        }
        get filters() {
            return ListModule.meta.filters;
        }
        async fetch(meta: MetaDatatable) {
            if (this.program.id) {
                const { data } = await getLotsPrescriber(this.program.id, {
                    ...meta,
                    page: meta.page - 1,
                    ...this.filters
                });
                this.lotIndexMap = {};
                (data.data || []).forEach((lot: any, index: number) => {
                    this.lotIndexMap[lot.id] = index;
                });
                this.checkLotPlans(data.data || []);
                return data;
            }
        }

        getPlanLoadDelay(lotId: number): number {
            const index = typeof this.lotIndexMap[lotId] === 'number' ? this.lotIndexMap[lotId] : 0;
            return index * 300;
        }

        async checkLotPlans(lots: Lot[]) {
            const lotsWithPlans = lots.filter(lot => lot.plan && lot.id);
            await Promise.all(
                lotsWithPlans.map(async (lot) => {
                    const url = this.planUrl(lot.plan);
                    try {
                        const res = await window.fetch(url, { method: 'HEAD' });
                        if (!res.ok && lot.id && !this.lotPlanBroken.includes(lot.id)) {
                            this.lotPlanBroken.push(lot.id);
                        }
                    } catch {
                        // CORS or network error — don't mark as broken, let browser handle on click
                    }
                })
            );
        }

        getClass (value: string) {
            let date1 = new Date(value);
            let date2 = new Date();
            let timeDiff = Math.abs(date2.getTime() - date1.getTime());
            let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
            if (diffDays <= 7) {
              return 'success'
            } else if (diffDays > 7 && diffDays <= 15) {
              return 'warning'
            }else if (diffDays <= 30) {
              return 'danger'
            }else{
              return 'danger'
            }
      }

      getClassFlux(value: boolean) {
          if(value == true) {
            return 'green';
          }else{
            return 'orange';
          }
      }

     get privateMode() {
                return FiltersModule.privateMode;
            }

            get isPrivateMode() {
                return FiltersModule.privateMode;
            }

        onShowMap(program: Program) {
            MapModule.showOnMap(program);
        }

        isLotSelected(lot: Lot) {
            const el = ListModule.lotsSelected.find(x => x.id === lot.id);
            if (el !== undefined) return true;
            return this.isLotDenounceSelected(lot);
        }

        isLotDenounceSelected(lot: Lot): boolean {
            try {
                const raw = localStorage.getItem('denounce_selected_lot_ids');
                if (!raw) return false;
                const ids: number[] = JSON.parse(raw);
                return ids.includes(lot.id as number);
            } catch (e) {
                return false;
            }
        }

        get isDenounceSelected(): boolean {
            try {
                const raw = localStorage.getItem('denounce_selected_program_ids');
                if (!raw) return false;
                const ids: number[] = JSON.parse(raw);
                return ids.includes(this.program.id as number);
            } catch (e) {
                return false;
            }
        }

        get isRestricted() {
            return AuthModule.isRestricted
        }

        isRecent(date: string) {
            const now = new Date().getTime();
            const pDate = new Date(date).getTime();
            const diff = now - pDate;

            if (diff < 7 * 24 * 60 * 60 * 1000) {
                return true;
            }
        }

        addBr(value: string) {
            return value.replace(/(?:\r\n|\r|\n)/g, '<br />');
        }


        getTaxSystemColor(taxSystems: string[]) {
            if (taxSystems.length > 0) {
                const color = getTaxSystemColor(taxSystems[0]);
                if (color) {
                    return color;
                }
            }

            return 'var(--vs-primary)';
        }

        getTaxSystemValue(taxSystem: string) {
            return getTaxSystemValue(taxSystem);
        }

        get showBoostPrescriber() {
            return (
              this.program.is_boost_prescriber
              && this.program.boost_comment_prescriber
              && this.program.boost_due_date_prescriber
              && moment().isBefore(this.program.boost_due_date_prescriber)
            );
        }

        get showBoostCustomer() {
            return (
              this.program.is_boost_customer
              && this.program.boost_comment_customer
              && this.program.boost_due_date_customer
              && moment().isBefore(this.program.boost_due_date_customer)
            );
        }

        get isRevente(): boolean {
            if (this.program && this.program.tax_system) {
                if (
                    this.program.tax_system.includes('Revente LMNP Divers') ||
                    this.program.tax_system.includes('Revente LMNP EHPAD') ||
                    this.program.tax_system.includes('Revente LMNP Rés') ||
                    this.program.tax_system.includes('Revente LMNP Étudiant') ||
                    this.program.tax_system.includes('Revente LMNP Sénior') ||
                    this.program.tax_system.includes('Revente LMNP Tourisme') ||
                    this.program.tax_system.includes('Revente fin défiscalisation')
                ) {
                    return true;
                }
            }
            return false;
        }




        get isValidBailDuration(): boolean {
            return (this.program.bail_duration != null && this.program.bail_duration > 0) ||
                (this.program.date_fin_bail != null);
        }

        get remainingBailDuration(): string {
    if (!this.program || !this.program.date_fin_bail) {
        return 'NC';
    }

    const today = moment();
    const endDate = moment(this.program.date_fin_bail);

    if (endDate.isBefore(today)) {
        const nextRenewalDate = moment(this.program.date_fin_bail).year(today.year());

        if (nextRenewalDate.isBefore(today)) {
            nextRenewalDate.add(1, 'year');
        }

        const formattedDate = nextRenewalDate.format('D MMMM YYYY');

        return `${formattedDate} (Tacite reconduction)`;
    }

    return endDate.format('D MMMM YYYY');
}


        openProgramInTab() {
            const programName = this.program.name || `Programme N° ${this.program.id}`;
            this.$root.$emit('openProgramTab', this.program.id, programName);
        }



        getRandomPlaceholderImage(programId: number): string {
            const imageNumber = (programId % 30) + 1;
            return require(`../../assets/images/special/${imageNumber}.png`);
            }



        isValidDureeUsufruit(value: number | null) {
        return value != null && value >= 1 && value <= 30;
    }

    isValidValeurNuePro(value: number | null) {
        return value != null && value >= 30 && value <= 90;
    }

    isValidDemembrement(duree: number | null, valeur: number | null) {
        return this.isValidDureeUsufruit(duree) && this.isValidValeurNuePro(valeur);
    }

    async openPlanUrl(plan: any, lot?: any) {
        const url = this.planUrl(plan);
        try {
            const res = await window.fetch(url, { method: 'HEAD' });
            if (res.ok) {
                window.open(url, '_blank', 'noopener,noreferrer');
            } else {
                if (lot && lot.id && !this.lotPlanBroken.includes(lot.id)) {
                    this.lotPlanBroken.push(lot.id);
                }
                (this as any).$vs.notify({
                    color: 'warning',
                    position: 'top-right',
                    title: 'Plan non disponible',
                    text: 'Le fichier plan de ce lot est introuvable sur le serveur.',
                });
            }
        } catch {
            // CORS or network error — open directly and let the browser handle it
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    }
    }
